import React, { Component } from 'react'
import classNames from 'classnames'
import { compose } from 'recompose'

import { Text } from 'components/base'
import { Button } from 'components/base'
import acknowledgeAllNotifications from 'components/Notifications/dataSync/acknowledgeAll'

class Header extends Component {
  onClickAcknowledgeAllNotifications = () => {
    this.props.acknowledgeAllNotifications()
  }

  render() {
    return (
      <div
        className={classNames(
          'position-relative',
          'center-text',
          'background-shade-100 border-bottom-medium border-shade-50 padding-horizontal-large padding-vertical-normal'
        )}
        style={{ height: 64 }}
      >
        <Button.Primary
          className="position-absolute"
          style={{ top: '12px', right: '20px' }}
          onClick={this.onClickAcknowledgeAllNotifications}
        >
          Mark all as read
        </Button.Primary>
        <Text.Subtitle>Notifications</Text.Subtitle>
        <div className="font-size-normal font-weight-medium shade-30">
          Where your team needs you
        </div>
      </div>
    )
  }
}

export default compose(acknowledgeAllNotifications())(Header)
